import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_nsti_stock_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    import_file_hdr_guid: fromDatatype.GuidDataFieldInterface;
    code:fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    type: fromDatatype.VarcharDatatypeInterface;
    category_code: fromDatatype.VarcharDatatypeInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    location_code: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    gl_code: fromDatatype.VarcharDatatypeInterface;
    purchase_date: fromDatatype.TimestampTzDatatypeInterface;
    purchase_price: fromDatatype.NumericDatatypeInterface;
    serial_number: fromDatatype.VarcharDatatypeInterface;
    warranty_expiry: fromDatatype.TimestampTzDatatypeInterface;
    employee_name: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_nsti_stock_import_file_helper_RowClass implements bl_fi_nsti_stock_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    import_file_hdr_guid: fromDatatype.GuidDataFieldInterface;
    code:fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    type: fromDatatype.VarcharDatatypeInterface;
    category_code: fromDatatype.VarcharDatatypeInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    location_code: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    gl_code: fromDatatype.VarcharDatatypeInterface;
    purchase_date: fromDatatype.TimestampTzDatatypeInterface;
    purchase_price: fromDatatype.NumericDatatypeInterface;
    serial_number: fromDatatype.VarcharDatatypeInterface;
    warranty_expiry: fromDatatype.TimestampTzDatatypeInterface;
    employee_name: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}